import React, { Component } from "react"
import Radium from "higher-order-components/configured-radium/"
import { AnimatedCheckIcon } from "containers"
import swatch from "./swatch.svg"

class RadioIcon extends Component {
  /**
   * @param {String} icon - URL for icon asset.
   * @returns {ReactElement} React Component
   */
  render() {
    return (
      <div
        style={[
          styles.base,
          { backgroundImage: `url(${this.props.icon})` },
          this.props.hover || this.props.active ? styles.active : ""
        ]}
        data-test="swatch-icon">
        <div style={styles.swatch} />
        {this.props.active && <AnimatedCheckIcon />}
      </div>
    )
  }
}
const styles = {
  base: {
    margin: ".25em",
    width: "4.25em",
    height: "4.25em",
    display: "inline-block",
    backgroundSize: "60%",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    transition: ".25s",
    position: "relative",
    transform: "translate3d(0, 0, 0)"
  },
  swatch: {
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    width: "100%",
    backgroundImage: `url(${swatch})`
  },
  active: {
    backgroundSize: "94%"
  }
}

export default Radium(RadioIcon)



// WEBPACK FOOTER //
// ./src/components/icons/radio-icon/index.jsx